import { render, staticRenderFns } from "./ComTitle.vue?vue&type=template&id=0b07a1ab&scoped=true"
import script from "./ComTitle.vue?vue&type=script&lang=js"
export * from "./ComTitle.vue?vue&type=script&lang=js"
import style0 from "./ComTitle.vue?vue&type=style&index=0&id=0b07a1ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07a1ab",
  null
  
)

export default component.exports